import { Prop, Vue, Component } from 'vue-property-decorator'

@Component
export default class CropperContainer extends Vue {
  @Prop({ type: Boolean, default: false })
  private readonly definedImage!: boolean
  @Prop({ type: Number, required: true })
  private readonly cropperAspectRatio!: number
  @Prop({ type: Boolean, default: false })
  private readonly stencilAspectRatioIsDinamic!: boolean
  @Prop({ type: Boolean, default: true })
  private readonly hiddenBorderStencil!: boolean
  @Prop({ type: String })
  private readonly cropperBgColor?: string
}
